<template>
	<div class="about">
		<div class="description mb-30">企業理念に則った行動をしたあの人に賞賛を贈りたいとき、ありがとうやおめでとうの気持ちを伝えたいときなど。今まで表現出来なかった感謝の気持ちをコインとして贈り合い、お互いを高め合いましょう！</div>

		<div class="vision">
			<div class="sv-title mb-20">ほほえみ企業理念</div>
			<div class="vision-paragraph">私たちは幸せな社会創りのために、楽しく夢を叶え信頼を築くことで「ほほえみ」と「感動」を生み出し、届けます。</div>
			<div class="vision-paragraph">スタッフが学び成長する為に会社が存在し、その結果、会社も成長する。</div>
			<div class="vision-paragraph">会社とスタッフが一緒になって“楽しみ”ながら“学び”“働く”環境を創る。</div>
			<div class="vision-paragraph">会社とスタッフが一緒になって“ほほえみ”と“感動”を生み出すサービスを提供する。</div>
			<div class="vision-paragraph">会社とスタッフ、取引先が一緒になって、“ありがとう“と“達成感”と“利益”を追求する。</div>
		</div>

		<div class="mt-30 mb-20 tm section-title">コインの説明</div>

		<div class="coin-list-wrap">
			<div class="coin-list" v-for="(row, index) in coins" :key="index">
				<div class="half-top horizontal-center" @click="onListClick(index)">
					<img :src="row.image" class="coin-image"/>
					<div class="coin-name bold18">{{ row.name }}コイン</div>
					<img :src="arrowIcon(index)" class="arrow" />
				</div>

				<transition name="slide">
					<div v-show="row.isOpen" class="wrapup-wrap">
						<div class="wrapup-wrap-contents">
							<div class="wrapup-wrap-contents-pc">
								<div class="text-center">
									<img :src="row.image"/>
								</div>
								<div class="wrapup-body word-wrap">{{ row.wrapup }}</div>
							</div>
							<b-button type="is-success" class="max-w-button mt-30 mb-20" @click="onDetailClick(row)">もっと詳しく</b-button>
						</div>
					</div>
				</transition>
			</div>

			<div v-if="coinDummy > 0">
				<div class="coin-dummy" v-for="n in coinDummy" :key="'cd-' + n" style="visibility: hidden;"></div>
			</div>
		</div>

		<b-modal :active.sync="isModalActive">
			<div class="coin-detail-modal text-center">
				<div class="sv-title">{{ modalName }}コイン</div>
				<img :src="modalImage" class="mt-30 mb-20"/>
				<div class="detail word-wrap">{{ modalBody }}</div>
			</div>
		</b-modal>
	</div>
</template>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

$contentPadding: 20px;
.about {
	font-size: 18px;

	.coin-detail-modal {
		background: #fff;
		overflow: scroll;
		padding: $contentPadding;
		height: 70vh;

		.sv-title {
			font-size: 26px;
		}

		.detail {
			text-align: left;
		}
	}

	.coin-list {
		background: #fff;
		margin-bottom: 15px;

		.wrapup-wrap {
			height: 350px;
			overflow: hidden;
			border: $commonBorder;

			.wrapup-wrap-contents {
				height: 320px;
				overflow: scroll;
				padding: $contentPadding;
				font-size: 15px;
				font-weight: $extraBold;

				.wrapup-body {
					margin-top: 30px;
				}
			}
		}

		.slide-enter-active, .slide-leave-active {
			transition: all .3s;
		}
		.slide-enter, .slide-leave-to {
			height: 0;
		}

		.half-top {
			border: $commonBorder;
			height: 73px;
			padding: 3px $contentPadding;

			.coin-image {
				width: 55px;
				height: 57px;
				margin-right: 20px;
			}

			.arrow {
				margin-left: auto;
			}
		}
	}

	.description {
		padding: 0 $contentPadding;
	}

	.vision {
		background: #fff;
		padding: $contentPadding;

		.vision-paragraph {
			margin-bottom: 10px;
		}

		.sv-title {
			font-size: 26px;
		}
	}
}

@media screen and (min-width: $breakPoint) {
	/deep/ .modal-content {
		max-width: 500px !important;
	}

	.vision {
		margin-left: 150px;
		margin-right: 150px;
		padding: 50px !important;
	}

	.coin-list-wrap {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;

		.coin-dummy {
			width: 302px;
		}
		.coin-list {
			width: 302px;

			.half-top {
				border-bottom: none !important;
				display: block !important;
				text-align: center;
				padding: 20px !important;
				height: 220px !important;

				.coin-name {
					margin: 20px 0 !important;
				}

				.coin-image {
					display: block !important;
					width: 141px !important;
					height: 147px !important;
					margin: 0 auto !important;
				}
			}

			.arrow {
				display: none;
			}

			.wrapup-wrap {
				border-top: none !important;
				height: 250px;

				.wrapup-wrap-contents {
					overflow: hidden !important;

					.wrapup-wrap-contents-pc {
						height: 140px;
						overflow: scroll;

						.wrapup-body {
							margin-top: 0;
						}
					}
					img {
						display: none;
					}
				}
			}
		}
	}
}
</style>

<script>

export default {
	name: 'About',
	data () {
		return {
			coins: [],
			isModalActive: false,
			modalName: '',
			modalImage: '',
			modalBody: '',
			coinDummy: 0,
		}
	},
	created() {
	},
	mounted() {
		this.init();
		//setTimeout(function() {
		//	window.scrollBy(0, 3000);
		//},1000);
	},
	methods: {
		onDetailClick: function(data) {
			this.modalName = data.name;
			this.modalImage = data.image;
			this.modalBody = data.detail;
			this.isModalActive = true;
		},
		onListClick: function(index) {
			let tmp = this.coins[index];
			tmp.isOpen = !tmp.isOpen;
			this.coins.splice(index, 1, tmp);
		},
		arrowIcon: function(index) {
			let direction = this.coins[index].isOpen ? 'up' : 'down';
			return require('@/assets/icons/arrow_' + direction + '_gray.svg');
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'coins/';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.coins = res.data;
				for (let i in this.coins) {
					this.coins[i].isOpen = !this.$utils.isSp();
				}

				this.coinDummy = 4 - (this.coins.length % 4);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
